import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper } from '@mui/material';
import RecentActivity from '../components/RecentActivity';

const ActivityLogPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 2 }}>
        <RecentActivity title={t('activity.title')} limit={30} />
      </Paper>
    </Box>
  );
};

export default ActivityLogPage;
